import React, { useEffect } from "react";
import { Card, CardWithStatus } from "../../../components/Cards";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getStoreManagementStats } from "../../../redux/StoreManagement/storeManagementActions";

const StoreStatsCards = () => {

  const dispatch = useDispatch();

  const {
    totalStores,
    totalStoreManagers,
    stockRequests,
    stockRequestsUrgent,
    statsLoading,
  } = useSelector((state) => state.storeManagement);

  const cards = [
    {
      title: "Total Stores",
      subtitle: statsLoading ? "..." : totalStores.toString(),
      href: "/store-management/all-stores",
      type: "basic",
    },
    {
      title: "Store Managers", 
      subtitle: statsLoading ? "..." : totalStoreManagers.toString(),
      href: "/store-management/managers",
      type: "basic",
    },
    {
      title: "Stock Request",
      subtitle: statsLoading ? "..." : stockRequests.toString(),
      href: "/store-management/stock-requests",
      type: "status",
      hasStatus: stockRequestsUrgent > 0,
      status: "Urgent",
    },
  ];

  useEffect(() => {
    // Dispatch action to fetch store management stats when component mounts
    dispatch(getStoreManagementStats());
  }, [dispatch]);

  return (
    <>
      {cards.map((card, index) => {
        if (card.type === "status") {
          return (
            <CardWithStatus
              key={index}
              title={card.title}
              subtitle={card.subtitle}
              href={card.href}
              hasStatus={card.hasStatus}
              status={card.status}
            />
          );
        }
        
        return (
          <Card
            key={index}
            title={card.title}
            subtitle={card.subtitle}
            href={card.href}
          />
        );
      })}
    </>
  );
};

export default StoreStatsCards;